'
<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>覆盖查询管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="卖场名称"
                        prop="marketid">
            <el-select
              v-model="search.marketid"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethodMarket"
              :loading="loading">
              <el-option
                v-for="item in markets"
                :key="item.id"
                :label="item.marketname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询距离"
                        prop="distance">
            <el-input-number v-model="search.distance"
                             :min="100"
                             label="最小"></el-input-number>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="userid"
                         label="用户ID"
                         min-width="90">
          <template slot-scope="scope">
            <router-link :to="'/users/table?keyword='+scope.row.userid">
              <span>{{scope.row.userid}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="order_count"
                         label="工单数"
                         min-width="120"></el-table-column>
        <el-table-column prop="userfinishtime"
                         label="最近时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="latesttime_title"
                         label="最近时间工单"
                         min-width="120"></el-table-column>
        <el-table-column prop="distance"
                         label="最近距离"
                         min-width="120">
          <template slot-scope="scope">
            <span>{{parseInt(scope.row.distance*1000)}}米</span>
          </template>
        </el-table-column>
        <el-table-column prop="nearest_title"
                         label="最近距离工单"
                         min-width="120"></el-table-column>
        <el-table-column prop="status"
                         label="用户状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="item.value === scope.row.status">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="currentstatus"
                         label="用户当前状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currentstatus"
                  v-if="item.value === scope.row.currentstatus">{{item.label}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../user-cover.rules.js'
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      searchRules,
      loading: false,
      search: {
        marketid: null,
        distance: 100,

      },
      searchFieldType: {
        marketid: Number,
      },
      isLoadTableInBeforeRouteEnter: false,
      isLoadTableInBeforeRouteUpdate: false,
      exportHeader: [
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'order_count',
          text: '工单数',
        },
        {
          key: 'userfinishtime',
          text: '最近时间',
        },
        {
          key: 'latesttime_title',
          text: '最近时间工单',
        },
        {
          key: 'distance',
          text: '最近距离',
        },
        {
          key: 'latesttime_title',
          text: '最近距离工单',
        },
        {
          key: 'strstatus',
          text: '用户状态',
        },
        {
          key: 'strcurrentstatus',
          text: '用户当前状态',
        },
      ],
      markets: [],
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.options,
  }),
  // 路由更新时
  beforeRouteUpdate (to, from, next) {
    if (to.query.marketid) {
      // 处理路由参数
      let queryParams = this.getRouterQueryParams(to.query)
      // 加载表格数据
      this.loadTableData(queryParams)
    }
    // 继续加载路由
    next()
  },
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getUserCoverTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      let self = this
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('getUserCoverTable', params),
        requestParams: this.search,
        getResponseData (data) {
          for (let m = 0; m < data.data.length; m++) {
            for (let i = 0; i < self.options.currentstatus.length; i++) {
              if (self.options.currentstatus[i].value === parseInt(data.data[m].currentstatus)) {
                data.data[m].strcurrentstatus = self.options.currentstatus[i].label
              }
            }
            for (let n = 0; n < self.options.status.length; n++) {
              if (self.options.status[n].value === parseInt(data.data[m].status)) {
                data.data[m].strstatus = self.options.status[n].label
              }
            }
            data.data[m].distance = data.data[m].distance * 1000 + '米'
          }
          return data
        },
      })
    },
    remoteMethodMarket (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          request.alert('queryMarket', {cover_keyword: query, per_page: 50, current_page: 1}).then(({data}) => {
            this.markets = data.data
            this.loading = false
          })
        }, 500)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/user-cover/pages/UserCoverTable.vue